<template>
  <v-autocomplete
    v-model="form[fieldName]"
    :items="graph[fieldName].items"
    :label="label"
    item-text="displayName"
    item-value="mailNickname"
    :search-input.sync="search[fieldName]"
    :loading="graph[fieldName].isLoading"
    placeholder="Start typing to search"
    outlined
    :chips="multiselect"
    :multiple="multiselect"
    :small-chips="multiselect"
    :deletable-chips="multiselect"
    :dense="!multiselect"
    hide-no-data
    :error-messages="errorMessages"
  >
    <template v-slot:item="{ item }">
      <v-list-item-title>{{ item.displayName }}</v-list-item-title>
    </template>
  </v-autocomplete>
</template>

<script>
import FormFieldGraphSearch from '@/mixins/FormFieldGraphSearch'

export default {
  name: 'UserSelect',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    label: String,
    multiselect: Boolean,
    errorMessages: Array
  },
  mixins: [FormFieldGraphSearch],
  data () {
    return {
      graphBasedFields: [this.multiselect ? 'users' : 'user'],
      fieldName: this.multiselect ? 'users' : 'user'
    }
  },
  methods: { },
  watch: {
    value (v) {
      this.form = v
    }
  }
}
</script>
